import classes from './dropDown/cppDropDown.scss';
import SceDropDown from './dropDown/cppTextDropDown';
import AddPhoneDialogBox from './dropDown/addPhoneDialogBox.js';
import EditPhoneNumberDialogBox from './dropDown/editPhoneDialogBox.js';

import SceButton from '../../../../../../../Common/CommonComponents/sceButton';
import DeletePhoneNumberDialog from './deletePhoneNumberDialog';
import { getLocalizedStrings } from './dropDown/manageAlertPreferencesDropdownString';
import NotificationHelper from './dropDown/notificationHelper';

class SetUpVoiceDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('mobileText');
    this.state = {
      additionalInfoStateOpen: [false, false, false],
      isRemoveDialog: false, isGlobalError: false,
      addPhoneDialog: false, newPhoneNo: '',
      phonePlaceholder: 'select Phone Number',
      editDialog: false,
      deletePhoneNumberDialog: false,
      businessPatner:this.props.businessPartner,
      addPhoneNum: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false, encryptedPhoneNumber: "", },
      editPhoneNum: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false, encryptedPhoneNumber: "", },
      Phone: this.props.dropDownData.phoneSet,
      selectedPhoneNo: !_.isEmpty(this.props.premiseData.preferVoice) ? this.props.premiseData.preferVoice : 'Select Phone Number',
      editVal: '',
      selectedMaskedPhoneNo : !_.isEmpty(this.props.premiseData.preferVoice) ? app.appUtil.maskPhoneNumberWithhyphenX(app.appUtil.formatPhoneNumber(this.props.premiseData.preferVoice)) : 'Select Phone Number',
      addOptions: ['Landline', 'Mobile'],
      editOptions: ['Landline', 'Mobile'],
      selectedOptions: '', radioErrorState: false, validateRadioInputsForcibly: false, selectedOptionValidStyle: '', radioOutline: '',
      showHintMessage: false,
      showLoadingIndicator: false,
      isLocalError: false, encDeleteValue: "",
      placeholder:!_.isEmpty(this.props.selectedValue) ? this.props.selectedValue : 'Enter Phone',
    };
  }
  componentWillMount() {
    this.getPhoneList(this.props.dropDownData.phoneSet);
  }
  componentWillReceiveProps(nextProps) {
    this.getPhoneList(nextProps.dropDownData.phoneSet);
  }
  getPhoneList(phoneList) {
    let that = this;
    let selectedPhone = phoneList.filter((phone) => {
      return phone.value !== 'addPhone' || phone.value !== 'No phone alerts';
    });
    let voiceValueArr = selectedPhone.map((obj)=>obj.telephoneNumber);
    let selectBoxPhoneList = selectedPhone.map(function (phone, index) {
      let telephoneNumber = NotificationHelper.formatPhoneNumWithStar(phone.telephoneNumber);
      let phoneUI = <div>
          <span className={classes.sceEmailwrap}>
            <span className={classes.scePhoneListStyle}>{telephoneNumber} </span>
            <span className={classes.scePhoneAlign}> <span className={classes.scePhoneStyle}>
              {phone.standardIndicatorVoice === "X"  ? 
                <span className={'pull-right ' + classes.sceEmailDelete + " " + classes.sceTooWrap} id={telephoneNumber + '_' + index} index={index}>
                  <span className={classes.sceQuestion}>?</span> 
                  <span className={classes.sceTooltip}>{that.strings.voiceTooltip} </span> 
                </span> :
                <span className={classes.scePhoneAlign}> 
                  <span className={classes.scePhoneStyle}>
                    <span id={'deleteChild_'+telephoneNumber + '_' + index + that.props.id+ that.props.dropdownDiffererentiator} index={index} onClick={() => that.onDeleteDialogClick()} className={'pull-right ' + classes.sceDelete + " " + classes.scePhoneBtn}>Delete</span>
                    <span id={'modifyChild_'+telephoneNumber + '_' + index + that.props.id+ that.props.dropdownDiffererentiator} index={index} onClick={() => that.onEditDialogClick()} className={'pull-right ' + " " + classes.scePhoneBtn}>Modify</span>
                  </span>
                </span>
              }
            </span></span> 
          </span>
      </div>;
      return {
        name: telephoneNumber, modifiedName: phoneUI, value: telephoneNumber, encryptedPhoneNumber: phone.encryptedPhoneNumber, type: phone.type, indicatorSmsEnabled: phone.indicatorSmsEnabled, indicatorTelephone: phone.indicatorTelephone
      };
    });
    
    this.setState({ Phone: selectBoxPhoneList }, () => { });
  }
  onHintIconClick = (e) => { 
    this.setState(...this.state, {showHintMessage: !this.state.showHintMessage});
  };
  onAddPhoneDialogClick = () => { this.setState(...this.state, { addPhoneDialog: !this.state.addPhoneDialog }); }
  
  onAddPhoneConfirmDialogClick = (e,name,value,encVal) => {
    this.props.onModifyCustomerPreference('voice', encVal, value);    
  }
  onEditDialogClick = () => {
    this.setState(...this.state,{editDialog: !this.state.editDialog});
  }
  onDeleteDialogClick = () => {
    this.setState(...this.state, { deletePhoneNumberDialog: true });
  }
  onDeleteCancelClickHandler = (e) => {
    e.preventDefault();
    this.setState(...this.state, { deletePhoneNumberDialog: false});
  }
  onEditPhoneConfirmDialogClick = () => {
    let updatedState = { ...this.state };
    if(updatedState.editPhoneNum.isError || updatedState.showLoadingIndicator) return;
    var editPhoneNum =updatedState.editPhoneNum.encryptedPhoneNumber;
    var existingVoicePreference = updatedState.Phone.filter(item=> item.encryptedPhoneNumber === editPhoneNum);
    updatedState.editPhoneNum.isError = existingVoicePreference.length>0 ? true : false;
    updatedState.editPhoneNum.errorMsg = updatedState.editPhoneNum.isError ? 'Preference already existing' : '' ;
    !updatedState.editPhoneNum.isError ? updatedState.editDialog = false : null;
    updatedState.editPhoneNum.isError ? this.setState(updatedState) : 
    this.setState(updatedState, () =>{
      this.props.onModifyCustomerPreference('voice', editPhoneNum, updatedState.editPhoneNum.value);
    });
  }
  onDeletePhoneConfirmDialogClick = (e) => {
    this.props.onModifyCustomerPreference('voice', this.state.deleteEncValue, this.state.deleteValue);
  }

  retrievedataFromTextBoxes = (data) => {
      if(data.id === "addPhoneNum" ) {
      this.setState({ ...this.state, addPhoneNum: { ...this.state.addPhoneNum, isError: data.isError, value: data.value, errorMsg:data.isError?"Please enter valid number.":"" }, isLocalError:false }, ()=>{
        !data.isError ? this.getEncryptedNumber(data.id, data.value) : null;
      });
      }else
      this.setState({ ...this.state, editPhoneNum: { ...this.state.editPhoneNum, isError: data.isError, value: data.value, errorMsg:data.isError?"Please enter valid number.":"" }, isLocalError:false }, ()=>{
        !data.isError ? this.getEncryptedNumber(data.id, data.value) : null;
      });
  }
  handlePhoneClick = (data) => {
    var selectedPhone,selectedOptions;
    this.props.data.phoneSet.map((phone)=>{
      if(phone.encryptedPhoneNumber === data.encNum){
        selectedPhone={...phone};
      }
    });
    if(selectedPhone && (selectedPhone.indicatorTelephone==='' || selectedPhone.indicatorTelephone==='1')) selectedOptions='Landline';
    else if(selectedPhone && (selectedPhone.indicatorTelephone==='2' || selectedPhone.indicatorTelephone==='3')) selectedOptions='Mobile';
    this.setState({ deleteValue: data.value, deleteEncValue:data.encNum, selectedOptions: selectedOptions || '', selectedOptionValidStyle: selectedOptions || '', radioOutline: selectedOptions || ''});
    if (data.value === 'addPhone') {
      this.onAddPhoneDialogClick();
    }else if(data.modifyChild === 'modifyChild'){
      this.onEditDialogClick();
    }else if(data.modifyChild === 'deleteChild'){
      this.onDeleteDialogClick();
    }else {
      this.setState({ newPhoneNo: data.value ,selectedMaskedPhoneNo : app.appUtil.maskPhoneNumberWithhyphenX(app.appUtil.formatPhoneNumber(data.value))}, () => {
        this.onSelectDropDown(data);
      });
    }
  }
  onSelectDropDown = (e) => {
    var reqObj={...e};
    reqObj.id=this.props.id;
    this.props.onSelectDropDown(reqObj);
  }

  onMobileRadioClick = (e, keys) => {
    let newArr = (this.state.additionalInfoStateOpen).map((value, index) => {
      return (index === keys);
    });
    let updatedState = { ...this.state }, isConfirmDisabled = false ;
    updatedState.selectedOptions = e.target.value;
    this.setState({
      removeRadioButton: true, selectedOptions: e.target.value, validateRadioInputsForcibly: false, validateTextInputsForcibly: false, hasTextInputsError: false, clearTextElements: true, radioErrorState: false, additionalInfoStateOpen: newArr, radioOutline: e.target.value,
      selectedOptionValidStyle: e.target.value, editPhoneNum:{...this.state.editPhoneNum, errorMsg: '', isError:false}
    });
  }

  onRadioFocus = (e, keys) => {
    let newArr = (this.state.additionalInfoStateOpen).map((value, index) => {
      return (index === keys);
    });
    this.setState({ additionalInfoStateOpen: newArr });
  }
  onCancelClickHandler = (e) => {
    e ? e.preventDefault() : null;
    this.setState({
      ...this.state, deletePhoneNumberDialog: false, editDialog: false, confirmDeletePhoneDialog: false, addPhoneDialog: false, editPhoneNum: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false,selectedOptions: '', isDisabled: true }
    }, () => {});
  }
  render() {
    return (
      <div>
        {this.state.deletePhoneNumberDialog ?
          <DeletePhoneNumberDialog
            onConfirmDeletePhoneDialogClick={this.onDeletePhoneConfirmDialogClick}
            deleteValue={this.state.deleteValue}
            onCancelClickHandler={this.onDeleteCancelClickHandler}
          /> : null}
        <div className={classes.scePhoneNumber}>
          <SceDropDown id={'phoneNumberSelection_' + this.props.id+this.props.dropdownDiffererentiator}
            selectBoxData={this.state.Phone}
            placeholder={this.state.placeholder}
            validator={app.appUtil.validator}
            handleClick={this.handlePhoneClick}
            ariaLabel='phoneNumberSelectBox'
            errorMessage={this.props.isDropDownError ? 'Please select phone number' : this.props.isSameValueError ? 'Primary and Secondary Contact details cannot be same.':''}
            selectErrorMessage={'Please select phone number'}
            onDoneEnabledButton={this.props.onDoneEnabledButton}
            onAddPhoneDialogClick={this.onAddPhoneDialogClick}
            onEditDialogClick={this.onEditDialogClick}
            defaultText={this.state.selectedMaskedPhoneNo}
            data={this.state.data}
            isError={this.props.isDropDownError || this.props.isSameValueError}
            triggerOnClick={this.props.triggerOnClick}
            onAddPhoneConfirmDialogClick={this.onAddPhoneConfirmDialogClick}
            inputButtonText={this.props.inputButtonText}
            addContactEncValueArr={this.props.addContactEncValueArr}
          />
          {this.state.addPhoneDialog ?
            <AddPhoneDialogBox
              onAddPhoneDialogClick={this.onAddPhoneDialogClick}
              retrievedataFromTextBoxes={this.retrievedataFromTextBoxes}
              addPhoneNum={this.state.addPhoneNum}
              options={this.state.addOptions}
              selectedOptions={this.state.selectedOptions}
              selectedOptionValidStyle={this.state.selectedOptionValidStyle}
              radioOutline={this.state.radioOutline}
              onMobileRadioClick={this.onMobileRadioClick}
              onRadioFocus={this.onRadioFocus}
              onCancelClickHandler={this.onCancelClickHandler}
              onAddPhoneConfirmDialogClick={this.onAddPhoneConfirmDialogClick}
              isLocalError={this.state.isLocalError}
              showSpinner={this.state.showLoadingIndicator}
            /> : null}

          {this.state.editDialog ? <EditPhoneNumberDialogBox
            onEditPhoneConfirmDialogClick={this.onEditPhoneConfirmDialogClick}
            onEditDialogClick={this.onEditDialogClick}
            editPhoneNum={this.state.editPhoneNum}
            retrievedataFromTextBoxes={this.retrievedataFromTextBoxes}
            selectedOptions={this.state.selectedOptions}
            selectedOptionValidStyle={this.state.selectedOptionValidStyle}
            radioOutline={this.state.radioOutline}
            options={this.state.editOptions}
            onCancelClickHandler={this.onCancelClickHandler}
            onMobileRadioClick={this.onMobileRadioClick}
            deleteValue={this.state.deleteValue} 
            isLocalError={this.state.isLocalError}
            showSpinner={this.state.showLoadingIndicator} /> : null}

        </div>
      </div>
    );
  }
}

export default SetUpVoiceDropdown;
